import { render, staticRenderFns } from "./HomeButton.vue?vue&type=template&id=9a11fe68&scoped=true"
import script from "./HomeButton.vue?vue&type=script&lang=js"
export * from "./HomeButton.vue?vue&type=script&lang=js"
import style0 from "./HomeButton.vue?vue&type=style&index=0&id=9a11fe68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a11fe68",
  null
  
)

export default component.exports